// Firebase configuration for different environments
export const firebaseConfigs = {
  development: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "finvari-deploy.firebaseapp.com",
    projectId:  process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "finvari-deploy",
    storageBucket:  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "finvari-deploy.appspot.com",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "196321757321",
  },
  production: {
    // This will be loaded from /__/firebase/init.json in production
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: ""
  }
};

// Get the appropriate config based on environment
export const getNonDeployedFirebaseConfig = () => {
  if (process.env.NODE_ENV === 'production') {
    return firebaseConfigs.production;
  }
  return firebaseConfigs.development;
};
